export default __webpack_public_path__ + "assets/dollar.png";